import { render } from "./DSSCriterionDialog.vue?vue&type=template&id=650b4008&scoped=true"
import script from "./DSSCriterionDialog.vue?vue&type=script&lang=js"
export * from "./DSSCriterionDialog.vue?vue&type=script&lang=js"

import "./DSSCriterionDialog.vue?vue&type=style&index=0&id=650b4008&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650b4008"]])

export default __exports__